export default __webpack_public_path__ + "static/media/defaultStat.d7e027c4.gif";